// extracted by mini-css-extract-plugin
export default {"info":"Fc6NrrFRbp"};